import React from 'react';

export default function LoadingScreen({ size = 90, message }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--cream)', flexDirection: 'column', gap: '32px', padding: '20px' }}>
      <div style={{ width: `min(${size}px, 55vw)`, height: `min(${size}px, 55vw)`, position: 'relative' }}>
        <img
          src="/ggr-loading-logo.png"
          alt="Loading"
          style={{ width: '100%', height: '100%', objectFit: 'contain', animation: 'ggrZoom 1.6s ease-in-out infinite' }}
        />
        <div style={{
          position: 'absolute', inset: '-12%',
          border: '3px solid rgba(227,66,92,0.06)',
          borderTopColor: '#E3425C',
          borderRadius: '50%',
          animation: 'ggrSpin 1s linear infinite',
        }} />
        <style>{`
          @keyframes ggrSpin { to { transform: rotate(360deg); } }
          @keyframes ggrZoom {
            0%, 100% { transform: scale(0.88); }
            50% { transform: scale(1.10); }
          }
        `}</style>
      </div>

      {/* Shimmer skeleton cards */}
      <div style={{ width: '100%', maxWidth: '420px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div className="skeleton-card">
          <div className="skeleton skeleton-title" />
          <div className="skeleton skeleton-text" />
          <div className="skeleton skeleton-text skeleton-text-short" />
          <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
            <div className="skeleton" style={{ height: '32px', width: '80px', borderRadius: '20px' }} />
            <div className="skeleton" style={{ height: '32px', width: '80px', borderRadius: '20px' }} />
          </div>
        </div>
        <div className="skeleton-card">
          <div className="skeleton-row">
            <div className="skeleton skeleton-avatar" />
            <div style={{ flex: 1 }}>
              <div className="skeleton skeleton-title" style={{ width: '40%' }} />
              <div className="skeleton skeleton-text" style={{ width: '70%' }} />
            </div>
          </div>
          <div className="skeleton skeleton-text" />
          <div className="skeleton skeleton-text skeleton-text-short" />
        </div>
      </div>

      {message && <p style={{ color: 'var(--gray)', fontSize: '14px', fontWeight: 500, margin: 0 }}>{message}</p>}
    </div>
  );
}
